<template>
    <main-content v-if="$can('manage-collective-gateways', 'ipg-gateway')">
        <gateway-form :submit="createGateway" :psp="psp" :form_data="collective"></gateway-form>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import $ from "jquery";
import { collectiveService } from '@/common/api.service'
import { KTApp } from '@/plugins/core/app'
import { gatewayForm } from './components'
import {mapGetters} from "vuex";

export default {
    data () {
        return {
            collective: {
                port_config:{}
            },
        }
    },
    components: {
        'main-content': mainContent,
        'gateway-form': gatewayForm,
    },
    methods: {
        createGateway(){
            let form = $('#gateway_form')
            let btn = $('#submit_btn')

            KTApp.progress(btn)

            let form_data = this.collective

            if (typeof form_data.port_config === 'object') {
                form_data.port_config = JSON.stringify(form_data.port_config);
            }

            collectiveService.create(form_data).then(response => {
                this.$router.push('/collective')
            })
                .catch(({response}) => {
                    if(response.data) {
                        form.validate().showErrors(response.data.data)
                    }
                    this.showMsg(form, 'danger', response.data.message)
                })
                .finally(() => {
                    KTApp.unprogress(btn)
                })
        },
    },
    mounted() {
        this.$store.dispatch('collective/getActivePsp')
    },
    computed: {
        ...mapGetters('collective', ['psp'])
    }
}
</script>

<style>

</style>